import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialSignoutLogout: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.145 9.14v4.57h-6.1v3.05h6.1v4.57h1.52v-1.52h1.53v-1.52h1.52v-1.53h1.52v-3.05h-1.52v-1.52h-1.52v-1.52h-1.53V9.14zm-4.57 12.19h1.52v6.1h-1.52Zm0-19.81h1.52v7.62h-1.52Zm-6.1 28.96v-1.53h6.1v-1.52h-6.1V7.62h-1.52v22.86zm-6.09 0h4.57V32h-4.57Zm1.52-13.72h1.52v3.05h-1.52Zm0-10.66h3.05v1.52h-3.05Zm-4.57 22.85h3.05v1.53h-3.05Zm1.52-24.38h3.05V6.1h-3.05Zm-4.57 22.86h3.05v1.52h-3.05Zm1.53-24.38h3.04v1.52h-3.04Z\"/><path fill=\"currentColor\" d=\"M2.285 0v1.52H.765v25.91h1.52V3.05h1.53V1.52h16.76V0z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialSignoutLogout
